import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import api from "../api"; // your axios instance

function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch products from API
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // ✅ Correct endpoint: /Products
        const response = await api.get("/Products");
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // Handlers for actions
  const handleView = (id) => {
    alert(`View product with ID: ${id}`);
    // TODO: navigate to detail page or open modal
  };

  const handleEdit = (id) => {
    alert(`Edit product with ID: ${id}`);
    // TODO: navigate to edit form or open modal
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        await api.delete(`/Products/${id}`);
        setProducts(products.filter((prod) => prod.pID !== id));
      } catch (error) {
        console.error("Error deleting product:", error);
      }
    }
  };

  // Define columns for DataGrid
  const columns = [
    { field: "pID", headerName: "ID", width: 80 },
    { field: "pName", headerName: "Product Name", width: 200 },
    { field: "pPrice", headerName: "Price", width: 120 },
    { field: "pCategoryID", headerName: "Category ID", width: 120 },
    {
      field: "pImage",
      headerName: "Image",
      width: 150,
      renderCell: (params) =>
        params.value ? (
          <img
            src={`data:image/jpeg;base64,${params.value}`}
            alt={params.row.pName}
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
        ) : (
          <span>No Image</span>
        ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 300,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => handleView(params.row.pID)}
            style={{ marginRight: 8 }}
          >
            View
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            size="small"
            onClick={() => handleEdit(params.row.pID)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={() => handleDelete(params.row.pID)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <h2>Product Management</h2>
      <DataGrid
        rows={products}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10]}
        loading={loading}
        disableSelectionOnClick
        getRowId={(row) => row.pID} // ✅ use pID as unique row id
      />
    </div>
  );
}

export default Products;